import { axiosClient } from "./http-client.service";
import {
  BusinessSetting,
  ConnectorSetting,
  UserSettings,
  UserSettingsAmendment,
} from "../models/settings.model";
import { AgentDetailModel } from "../models/agent.model";
import { WhatsAppTemplate } from "../models/whatsapp.model";

export async function setupBusinessAccount(
  uid: string,
  wabaId: string,
  phoneNumberId: string,
  eventType: string,
): Promise<UserSettings> {
  const res = await axiosClient.patch(
    "/settings/user/setup/business-account",
    null,
    {
      params: {
        settingsId: uid,
        whatsAppEventType: eventType,
        wabaId,
        phoneNumberId,
      },
    },
  );

  return res.data;
}

export async function deleteTemplate(
  settingsId: string,
  id: string,
  name: string,
): Promise<any> {
  return await axiosClient.delete("/settings/user/template", {
    params: {
      id,
      name,
      settingsId,
    },
  });
}
export async function getAllTemplates(
  settingsId: string,
): Promise<WhatsAppTemplate[]> {
  const response = await axiosClient.get("/settings/user/templates", {
    params: {
      settingsId,
    },
  });
  return response.data;
}

export async function createTemplate(
  settingsId: string,
  updatedSettings: any,
): Promise<Record<string, any>> {
  const response = await axiosClient.post(
    "/settings/user/create/template",
    updatedSettings,
    {
      params: {
        settingsId,
      },
    },
  );
  return response.data;
}

export async function modifySettings(
  settingsId: string | null | undefined,
  updatedSettings: UserSettingsAmendment,
): Promise<UserSettings> {
  const queryParams = settingsId
    ? {
        settingsId,
      }
    : null;

  const response = await axiosClient.patch("/settings/user", updatedSettings, {
    params: queryParams,
  });
  return response.data;
}

export async function updateAgentStatus(
  settingsId: string,
  isActive: boolean,
): Promise<UserSettings> {
  const queryParams = {
    settingsId,
    isActive,
  };

  const response = await axiosClient.patch(
    "/settings/user/agent/status",
    null,
    {
      params: queryParams,
    },
  );
  return response.data;
}

export async function getUserSettingsById(
  settingsId: string,
): Promise<UserSettings> {
  let response;
  try {
    response = await axiosClient.get(`/settings/user/${settingsId}`);
    return response.data;
  } catch (e: any) {
    if (e?.status === 404) {
      return {
        id: settingsId,
        agentSettings: {} as AgentDetailModel,
        connectorSettings: [] as ConnectorSetting[],
        businessSettings: {} as BusinessSetting,
      } as UserSettings;
    }
    throw e;
  }
}
